/**
 * @file Album Folder Purchase Uniform Tag Modal Photos.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import { PHOTO_MODAL } from '../../../constants/modals';
import Button from '../../global/Button';
import { ALBUM_FOLDER_TAG_TYPE } from '../../../constants/album-folder-tags';
import IdentityAvatar from '../../global/identity/IdentityAvatar';
import ZoomInIcon from '../../icons/ZoomInIcon';
import { AVATAR_SIZE_72 } from '../../../constants/avatar-sizes';

class AlbumFolderPurchaseUniformTagModalPhotos extends Component {
  static propTypes = {
    tag: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      type: PropTypes.oneOf(Object.keys(ALBUM_FOLDER_TAG_TYPE)),
      uniform_enabled: PropTypes.bool,
      uniform_numbered: PropTypes.bool,
      uniform_different_home_and_away: PropTypes.bool,
      levels: PropTypes.shape({
        records: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
          }),
        ),
      }),
    }).isRequired,
    homeJersey: PropTypes.object,
    awayJersey: PropTypes.object,
    openModal: PropTypes.func.isRequired,
    onFileInputChange: PropTypes.func,
  };

  state = {
    homeJerseyUrl: null,
    awayJerseyUrl: null,
  };

  componentDidMount() {
    const { homeJersey, awayJersey } = this.props;

    this.getFileReader(homeJersey, 'homeJersey');
    this.getFileReader(awayJersey, 'awayJersey');
  }

  componentDidUpdate(prevProps) {
    const { homeJersey, awayJersey } = this.props;

    if (prevProps.homeJersey !== homeJersey) {
      this.getFileReader(homeJersey, 'homeJersey');
    }

    if (prevProps.awayJersey !== awayJersey) {
      this.getFileReader(awayJersey, 'awayJersey');
    }
  }

  getFileReader = (file, inputName) => {
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = readerEvent => {
      this.setState(() => ({
        [`${inputName}Url`]: readerEvent.target.result,
      }));
    };

    reader.readAsDataURL(file);
  };

  render() {
    const { tag, openModal, onFileInputChange } = this.props;

    const uniformEnabled = get(tag, 'uniform_enabled');
    const uniformPhotoUpload = false && uniformEnabled; // At the moment, this will be disabled
    const differentHomeAway = get(tag, 'uniform_different_home_and_away');

    if (!uniformPhotoUpload) {
      // At the moment, this will *always* happen.
      return null;
    }

    const { homeJerseyUrl, awayJerseyUrl } = this.state;

    return (
      <div className="mb-3">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-12">
              <div className="d-flex flex-column h-100 justify-content-end mt-1">
                {homeJerseyUrl ? (
                  <div className="d-flex w-100 mb-2 justify-content-center">
                    <IdentityAvatar
                      uploadedPhoto={{
                        url: homeJerseyUrl,
                      }}
                      size={AVATAR_SIZE_72}
                      className="m-auto"
                      onClick={() =>
                        openModal(PHOTO_MODAL, { photoUrl: homeJerseyUrl })
                      }
                    >
                      <span className="btn-identity-avatar-zoom">
                        <ZoomInIcon color="#0e84fe" />
                      </span>
                    </IdentityAvatar>
                  </div>
                ) : (
                  <p className="text-center text-sm">
                    Please provide a photo for Home Jersey
                  </p>
                )}

                <Button
                  btnBlock
                  btnStyle="secondary"
                  btnSize="sm"
                  onClick={() => {
                    this.homeJerseyInput.click();
                  }}
                >
                  {homeJerseyUrl
                    ? 'Change Home Jersey Photo'
                    : 'Upload Home Jersey Photo'}
                </Button>
              </div>

              <input
                id="upload-photo"
                type="file"
                accept="image/*"
                onChange={onFileInputChange}
                ref={ref => {
                  this.homeJerseyInput = ref;
                }}
                hidden
                name="homeJersey"
              />
            </div>
            {differentHomeAway && (
              <div className="col-sm-6 col-12">
                <div className="d-flex flex-column h-100 justify-content-end mt-1">
                  {awayJerseyUrl ? (
                    <div className="d-flex w-100 mb-2 justify-content-center">
                      <IdentityAvatar
                        uploadedPhoto={{
                          url: awayJerseyUrl,
                        }}
                        size={AVATAR_SIZE_72}
                        className="m-auto"
                        onClick={() =>
                          openModal(PHOTO_MODAL, { photoUrl: awayJerseyUrl })
                        }
                      >
                        <span className="btn-identity-avatar-zoom">
                          <ZoomInIcon color="#0e84fe" />
                        </span>
                      </IdentityAvatar>
                    </div>
                  ) : (
                    <p className="text-center text-sm">
                      Please provide a photo for Away Jersey
                    </p>
                  )}
                  <Button
                    btnBlock
                    btnStyle="secondary"
                    btnSize="sm"
                    onClick={() => {
                      this.awayJerseyInput.click();
                    }}
                  >
                    {awayJerseyUrl
                      ? 'Change Away Jersey Photo'
                      : 'Upload Away Jersey Photo'}
                  </Button>
                </div>

                <input
                  id="upload-photo"
                  type="file"
                  accept="image/*"
                  onChange={onFileInputChange}
                  ref={ref => {
                    this.awayJerseyInput = ref;
                  }}
                  hidden
                  name="awayJersey"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AlbumFolderPurchaseUniformTagModalPhotos;
